import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function PortalHeader({ user, onLogout, stage }) {
  const location = useLocation();
  const onApplication = location.pathname.startsWith("/application");
  const stageLabel = stage === 3 || onApplication
    ? "Founding Grower Application · Stage Three"
    : "Founding Grower Memorandum · Stage Two";

  return (
    <header className="border-b border-[var(--bloom-border)] bg-[var(--bloom-bg)] sticky top-0 z-40" data-testid="portal-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/portal" className="flex items-center gap-4" data-testid="portal-logo">
          <div className="bloom-seal">HBC<br/>2026</div>
          <div>
            <div className="font-serif text-xl leading-tight">Heritage Bloom Club</div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-[var(--bloom-ink-muted)]">{stageLabel}</div>
          </div>
        </Link>
        <div className="flex items-center gap-4">
          {user && (
            <>
              {user.role !== "admin" && (
                <nav className="hidden md:flex items-center gap-1" data-testid="portal-nav">
                  <Link
                    to="/portal"
                    className={`bloom-btn ${!onApplication ? "bloom-btn-outline" : "bloom-btn-ghost"}`}
                    data-testid="nav-portal-link"
                  >
                    Prospectus
                  </Link>
                  <Link
                    to="/application"
                    className={`bloom-btn ${onApplication ? "bloom-btn-outline" : "bloom-btn-ghost"}`}
                    data-testid="nav-application-link"
                  >
                    My Application
                  </Link>
                </nav>
              )}
              <div className="hidden md:block text-right">
                <div className="font-serif italic text-sm text-[var(--bloom-ink-soft)]">{user.name}</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-[var(--bloom-ink-muted)]">{user.role === "admin" ? "Administrator" : "Prospective Grower"}</div>
              </div>
              {user.role === "admin" && (
                <Link to="/admin" className="bloom-btn bloom-btn-ghost" data-testid="nav-admin-link">Admin</Link>
              )}
              <button onClick={onLogout} className="bloom-btn bloom-btn-ghost" data-testid="logout-btn">Sign Out</button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
